import { render, staticRenderFns } from "./ResidentDatePicker.vue?vue&type=template&id=0d66f146"
import script from "./ResidentDatePicker.vue?vue&type=script&lang=js"
export * from "./ResidentDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports